module.exports = __webpack_public_path__ + "static/media/middle.ff6832e3.png";